<template lang="pug">
  v-autocomplete(
    v-model="inputValue"
    :label="label"
    :search-input.sync="search"
    :items="items"
    item-value="id"
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    no-filter
    clearable
    :multiple="multiple"
    :return-object="returnObject"
  )
    template(v-slot:selection="data")
      | {{ data.item.profile.name || data.item.username }}
    template(v-slot:item="data")
      v-list-item-content
        v-list-item-title {{ data.item.profile.name || data.item.username }}
        v-list-item-subtitle(v-if="data.item.profile.name") {{ data.item.username }}

</template>

<script>
import { CRUDUsers } from '@/services/API/user';

export default {
  props: {
    region: { type: Number, default: null },
    mun: { type: Number, default: null },
    multiple: { type: Boolean, default: false },
    value: { type: [Number, Array], default: null },
    label: { type: String, default: 'Выберите пользователя' },
    returnObject: { type: Boolean, default: false },
    query: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      items: [],
      search: null,
      loading:false,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  watch: {
    region: {
      async handler(v) {
        if (!v) return;
        await this.loadItems();
      },
    },
    mun: {
      async handler() {
        await this.loadItems();
      },
    },
    search() {
      // Items have already been requested
      if (this.loading) return;
      // if (this.inputValue) return;
      this.loading = true;

      // Lazily load input items
      this.loadItems();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loadItems();
    },
    async loadItems() {
      const params = {
        'search[region_id]': this.region,
        'search[municipality_id]': this.mun,
        'search[username]': this.search,
        ...this.query,
      };
      this.loading = true;
      try {
        await CRUDUsers.getAll(params).then((response) => {
          this.items = response.data.data;
          this.loading = false;
        });
      } catch (err) {
        this.$toast.error(err);
      }
    },
  },
};
</script>
